'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _accounts = require('ifeis-isomorphic/lib/redux/actions/accounts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdminEditAccountsController = function () {
  function AdminEditAccountsController($ngRedux, fRouterHistoryService, $mdDialog, fAlert, msgService, fPrompt) {
    var _this = this;

    _classCallCheck(this, AdminEditAccountsController);

    this.edit = function ($event) {
      var account = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!account || account == {} || !account.fname) {
        return;
      } else {
        _this.originalAccountObject = _extends({}, account);
        _this._.$mdDialog.show({
          event: $event,
          controller: function controller($scope, $q) {
            $scope.cancel = function () {
              _this.searchText = '';
              _this._.$mdDialog.cancel();
            };

            $scope.account = _extends({}, account);

            $scope.responseToClick = function (account) {
              _this.searchText = '';
              _this._.$mdDialog.hide(account);
            };
          },
          template: ['<md-dialog ng-class="class">', '  <form novalidate name="form">', '  <md-content>', '    <md-subheader class="md-sticky-no-effect">Modify Account</md-subheader>', '    <div style="padding: 5px"><md-input-container class="prompt-input-container" style="width: 90%">', '      <label>First Name</label>', '      <input type="text" ng-model="account.fname" class="dialog-close" required />', '    </md-input-container></div>', '    <div style="padding: 5px"><md-input-container class="prompt-input-container" style="width: 90%">', '      <label>Last Name</label>', '      <input type="text" ng-model="account.lname" class="dialog-close" required />', '    </md-input-container></div>', '    <div><md-input-container class="prompt-input-container" style="width: 90%">', '      <label>Email</label>', '      <input type="text" ng-model="account.email" class="dialog-close" required />', '    </md-input-container></div>', '  </md-content>', '  <div class="md-actions" layout="row">', '    <md-button type="button" ng-click="cancel()" class="md-primary">Cancel</md-button>', '    <md-button type="submit" ng-disabled="form.$invalid" ng-click="responseToClick(account)">Save</md-button>', '  </div>', '  </form>', '</md-dialog>'].join("\n")
        }).then(function (data) {
          _this.searchText = '';
          var fname = data.fname,
              lname = data.lname,
              email = data.email;

          if (!fname || !lname || !email) {
            _this._.msgService.displayErrorMsg('Mandatory fields missing. Please enter all values.');
          }
          if (angular.equals(data, _this.originalAccountObject)) {
            _this._.msgService.displayErrorMsg('No change in the field values. Please try again.');
          } else {
            return _this._.$ngRedux.dispatch((0, _accounts.updateAccountByAdmin)(data)).then(function () {
              return _this._.msgService.displaySuccessMsg('Update successful');
            }).catch(function (eResponse) {
              var error = eResponse.errors.data;
              _this._.msgService.displayErrorMsg(error.errors[0].detail);
            });
          }
        });
      }
    };

    this.accounts = [];
    this.searchText = '';
    this._ = { $ngRedux: $ngRedux, $mdDialog: $mdDialog, fAlert: fAlert, msgService: msgService, fPrompt: fPrompt };
  }

  _createClass(AdminEditAccountsController, [{
    key: 'search',
    value: function search(searchText) {
      return this._.$ngRedux.dispatch((0, _accounts.searchAccountsForText)(searchText)).then(function (resp) {
        return resp.payload || [];
      });
    }
  }]);

  return AdminEditAccountsController;
}();

exports.default = angular.module('ifeis.routes.admin.edit-accounts', ['ui.router', 'ngMaterial']).config(function ($stateProvider) {
  $stateProvider.state('admin.edit-accounts', {
    url: '/edit-accounts',
    template: require('./tpl.html'),
    controller: AdminEditAccountsController,
    controllerAs: 'adminEditAccounts',
    ncyBreadcrumb: {
      label: 'Edit Accounts',
      parent: 'admin.dashboard'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/admin/edit-accounts/index.js
// module id = 513
// module chunks = 0